import React, { useEffect, useState } from 'react';
import '../common/css/pwInquiry.css';
import axios from 'axios';
import SaveModal from './modal/saveModal';

function PWInquiry() {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [userId, setUserId] = useState('');
    const [AuthNumber, setAuthNumber] = useState(true);
    const [PassAthNum, setPassAthNum] = useState(true);
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [timeLeft, setTimeLeft] = useState(180);
    const [isExpired, setIsExpired] = useState(false);
    const [pw, setPw] = useState(null);
    const [checkPW, setCheckPW] = useState(null);
    const [authValue, setAuthValue] = useState('');
    const [FindIdClick, setFindIdClick] = useState(true);

    useEffect(() => {
        if (timeLeft <= 0) {
            setIsExpired(true);
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    // 인증번호칸 hide 없앰
    const authNumber = async () => {
        try {
            if (userId === '') {
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('아이디을 입력해주세요.');
                setSaveStatus(false);
            } else if (name === '') {
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('이름을 입력해주세요.');
                setSaveStatus(false);
            } else if (email === '') {
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('이메일을 입력해주세요.');
                setSaveStatus(false);
            } else {
                setTimeLeft(180);
                const authInfo = { userId, name, email };
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }

                await axios.post(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/pwinquiry`,
                    authInfo,
                );

                setAuthNumber(false);
                setModalAction(() => () => setSaveStatus(true));
                setModalContent('인증번호가 발송되었습니다.');
                setSaveStatus(false);
            }
        } catch (error) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent(error.response.data.message);
            setSaveStatus(false);
        }
    };

    const passAuthNumber = async () => {
        try {
            const authInfo = { userId, name, email, authValue };
            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                isLocal = false;
            } else {
                isLocal = true;
            }

            const response = await axios.post(
                `${
                    isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/pwcheck`,
                authInfo,
            );
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('인증되었습니다.');
            setSaveStatus(false);
            setPassAthNum(false);
        } catch (error) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent(error.response.data.message);
            setSaveStatus(false);
        }
    };

    const findIdBtn = async () => {
        if (FindIdClick) {
            setFindIdClick(false);
        } else {
            try {
                if (pw != checkPW) {
                    setModalAction(() => () => setSaveStatus(true));
                    setModalContent('비밀번호가 동일하지 않습니다.');
                    setSaveStatus(false);
                    return;
                }
                const authInfo = { userId, name, email, checkPW };
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
            isLocal = true;
        } else {
            isLocal = false;
        }
                await axios.post(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/pwchange`,
                    authInfo,
                );
                setModalAction(() => () => (window.location.href = '/login'));
                setModalContent(`변경 완료되었습니다. \n 로그인 페이지로 이동합니다.`);
                setSaveStatus(false);
            } catch (error) {
                setModalAction(() => () => setSaveStatus(true));
                setModalContent(error.response.data.message);
                setSaveStatus(false);
            }
        }
    };

    return (
        <div className='content'>
            <div className='subp_h_wrap'>
                <div className='subp_h_list subp_h_home'>
                    <div>회원가입</div>

                    <div>비밀번호 찾기</div>
                </div>
            </div>
            <div id='bodyContainer'>
                <div className='member_wrap'>
                    <div className='member_right' id='idSearchBox'>
                        <div className='page_hgroup'>
                            <h3 className='title'>비밀번호 찾기</h3>
                        </div>
                        <table className='write_table for-mo__idsearch'>
                            <colgroup>
                                <col style={{ width: '190px' }} />
                                <col style={{ width: '600px' }} />
                            </colgroup>
                            <tbody>
                                <tr className='id_box'>
                                    <th>아이디</th>
                                    <td>
                                        <div className='boxed'>
                                            <input
                                                type='text'
                                                id='usrId'
                                                name='usrId'
                                                maxLength='60'
                                                value={userId}
                                                onChange={(e) => setUserId(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className='name_box'>
                                    <th>이름</th>
                                    <td>
                                        <div className='boxed'>
                                            <input
                                                type='text'
                                                id='usrNm'
                                                name='usrNm'
                                                maxLength='60'
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>이메일</th>
                                    <td>
                                        <div className='boxed'>
                                            <input
                                                type='text'
                                                id='usrNm'
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                            <input
                                                type='button'
                                                id='getHTelAuthNumber'
                                                value={AuthNumber ? '인증번호 받기' : '재발송'}
                                                className={`btn36 red sendAuthNumY mo-mt-btn ${
                                                    PassAthNum ? '' : 'hide'
                                                }`}
                                                onClick={authNumber}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr id='telAuthNumberArea' className={AuthNumber ? 'hide' : ''}>
                                    <th>인증번호 확인</th>
                                    <td>
                                        <div className='boxed' style={{ margin: '10px 0px' }}>
                                            <input
                                                type='text'
                                                id='txtAuthNumber'
                                                name='txtAuthNumber'
                                                maxLength='6'
                                                numberonly='true'
                                                value={authValue}
                                                onChange={(e) => setAuthValue(e.target.value)}
                                            />
                                            <input
                                                type='button'
                                                id='checkHTelAuthNumber'
                                                className={`btn36 red  ${PassAthNum ? '' : 'hide'}`}
                                                onClick={passAuthNumber}
                                                value={'확인'}
                                                style={{
                                                    backgroundColor: 'var(--color-red)',
                                                    border: '1px solid var(--color-red)',
                                                }}
                                            ></input>
                                        </div>
                                        <p
                                            className='description authNumberDesc'
                                            style={{ margin: '10px 0px' }}
                                        >
                                            <span className='authNumberTxt'>
                                                *이메일으로 전송된 인증번호 5자리를 입력해 주십시오.
                                            </span>
                                            [
                                            <span
                                                id='authTimeMin'
                                                className='redColor'
                                                style={{ color: '#DD0005', fontweight: 'bold' }}
                                            >
                                                {Math.floor(timeLeft / 60)}
                                            </span>
                                            <span>:</span>
                                            <span
                                                id='authTimeSec'
                                                className='redColor'
                                                style={{ color: '#DD0005', fontweight: 'bold' }}
                                            >
                                                {timeLeft % 60}
                                            </span>
                                            ]
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className={`write_table for-mo__idsearch ${FindIdClick ? 'hide' : ''} `}>
                            <colgroup>
                                <col style={{ width: '190px' }} />
                                <col style={{ width: '600px' }} />
                            </colgroup>
                            <tbody>
                                <tr className='name_box'>
                                    <th>비밀번호</th>
                                    <td className='firstPwChangeInput'>
                                        <div className='boxed'>
                                            <input
                                                type='password'
                                                id='usrPw'
                                                name='usrPw'
                                                maxLength='60'
                                                value={pw}
                                                onChange={(e) => setPw(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>비밀번호 확인</th>
                                    <td>
                                        <div className='boxed'>
                                            <input
                                                type='password'
                                                id='usrPwCheck'
                                                name='usrPwCheck'
                                                maxLength='60'
                                                value={checkPW}
                                                onChange={(e) => setCheckPW(e.target.value)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className={`btn_wrap ${PassAthNum ? 'hide' : ''}`}>
                            <div className='fl_c'>
                                <input
                                    type='button'
                                    value={FindIdClick ? '비밀번호 찾기' : '비밀번호 변경'}
                                    className='btn46 red'
                                    onClick={findIdBtn}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default PWInquiry;
